import { forwardRef } from 'react';
import { css } from '@emotion/react';
import { CloseX40x40 } from '@core/assets/CloseX40x40';
import { MODAL_CLOSE_BUTTON } from '@core/components/testIds';
import { useContextTranslation } from '@core/i18n';
import { ControlsButton } from '@src/core/components/ControlsButton/ControlsButton';
/**
 *
 */
export const ButtonClose = forwardRef(({ onClick, ...rest }, ref) => {
    const { t } = useContextTranslation();
    return (<ControlsButton className="cy-drawer_close" onClick={onClick} src={<div css={css `
              color: inherit;
              display: flex;
              align-items: center;
              justify-content: center;
            `}>
            <CloseX40x40 label="close"/>
          </div>} aria-label={t('player:Close modal')} data-testid={MODAL_CLOSE_BUTTON} ref={ref} {...rest}/>);
});
